import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './app/providers/AuthProvider';
import './shared/api/configureAxiosAuth';
// 全局样式按设计变量、基础规则、组件主题、共享原语的顺序加载。
import './styles/tokens.css';
import './styles/base.css';
import './styles/antd-mobile.css';
import './App.css';
import './styles/primitives.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <HashRouter>
      <App/>
    </HashRouter>
  </AuthProvider>
);
